import { Container } from "react-bootstrap";

const Error = ({message}) => {
    return (
        <div className="error text-center mt-5">
            <Container>
                <div className="text-bg-danger p-3">
                    <p className="m-0">Something went wrong</p>
                    {message && <p>{message}</p>}
                </div>
            </Container>
        </div>
    )
}

export default Error;